export default {
    titlePlaceholder: 'العنوان',
    messagePlaceholder: 'تفاصيل الرسالة',
    upgradeMembership: 'اعلاء العضوية',
    sendPicture: 'ارسل صورة',
    sendVoice: 'ارسل رسالة صوتية',
    sendVideo: 'ارسل رسالة فيديو',
    send: 'ارسل',
    audioNotSupported: 'البرنامج لا يدعم هذا النوع من الملف الصوتي',
    videoNotSupported: 'البرنامج لا يدعم هذا النوع من الفيديو',
    addTitle: 'عليك كتابة العنوان',
    addAudio: 'لم تقوم بتسجيل اي مكالمة',
    upgradeToListen: 'عليك اعلاء العضوية للاستماع الى كامل الرسالة الصوتية',
    upgradeToWatch: 'عليك اعلاء العضوية حتى مشاهدة الفيديو كاملا',
    upgradeToView: 'اعلاء العضوية لمشاهدة الصورة',
    upgradePopup: 'اعلاء العضوية حتى تستفيد من جميع خدمات الموقع',
    subscribe: 'اعلاء العضوية',
    emptyContactsList: 'لائحة المفضلين فارغة',
    emptyContactsList2: '',
    search: 'البحث'
}
